

export const CorreoAprobacion = (detalles) => {
    const EncabezadoRequisa = detalles?.detalles[0];
    const DetallesRequisa = detalles?.detalles;
  
    const formatDateTime = (dateTime) => {
      const date = new Date(dateTime);
      const formattedDate = date.toLocaleDateString();
      const formattedTime = date.toLocaleTimeString();
      return `${formattedDate} ${formattedTime}`;
    };
  
    if (EncabezadoRequisa) {
      return (
        <div>
          <div style={{ marginBottom: '10px' }}>
            <span style={{ fontWeight: 'bold' }}>Requisa: </span>{EncabezadoRequisa?.PurchaseRequest}
          </div>
          <div style={{ marginBottom: '10px' }}>
            <span style={{ fontWeight: 'bold' }}>Departamento: </span>{EncabezadoRequisa?.Area}
          </div>
          <div style={{ marginBottom: '10px' }}>
            <span style={{ fontWeight: 'bold' }}>Solicita: </span>{EncabezadoRequisa?.UserNameSolicita}
          </div>
          <div style={{ marginBottom: '10px' }}>
            <span style={{ fontWeight: 'bold' }}>Fecha de Solicitud: </span>{formatDateTime(EncabezadoRequisa?.DateCreated)}
          </div>
          
            {/* Subtítulo
            <div style={{ width: '75%', textAlign: 'center', margin: '0 auto', marginTop: '20px', marginBottom: '10px' }}>
            <h4 style={{ margin: 0 }}>Detalles de Requisa</h4>
            </div> */}

            {/* Tabla de detalles */}
            <table style={{ width: '75%', borderCollapse: 'collapse', fontSize: '14px', margin: '0 auto' }}>
            <thead>
                <tr>
                <th style={{ border: '1px solid black', backgroundColor: '#bee9fc' }}>Producto</th>
                <th style={{ border: '1px solid black', backgroundColor: '#bee9fc' }}>Código</th>
                <th style={{ border: '1px solid black', backgroundColor: '#bee9fc' }}>Unidad</th>
                <th style={{ border: '1px solid black', backgroundColor: '#bee9fc', width: '100px' }}>Cantidad</th>

                </tr>
            </thead>
            <tbody>
                {DetallesRequisa?.map((detalle, index) => (
                <tr key={index}>
                    <td style={{ border: '1px solid black', paddingLeft: '5px' }}>{detalle.NombreProducto}</td>
                    <td style={{ border: '1px solid black', textAlign: 'center' }}>{detalle.CodigoProducto}</td>
                    <td style={{ border: '1px solid black', textAlign: 'center' }}>{detalle.UnitName}</td>
                    <td style={{ border: '1px solid black', textAlign: 'center', width: '100px' }}>{detalle.Quantity.toFixed(2)}</td>

                </tr>
                ))}
            </tbody>
            </table>


        </div>
      );
    }
  
    return null;
  };
  